import { Component, OnInit, Input, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { AllReportText, MainReportText } from '../assist-data-element/assist-data-element.component';
import { AllTextReport } from '../../core/models/report-text.model';
const $ = require('jquery');
@Component({
  selector: 'acr-assist-report-text',
  template: `<ng-container *ngFor="let textReport of allTextReport; let lastitem = last">
  <dt class="text-capitalize">{{textReport.heading}}</dt>
  <dd>
    <p class="white-space-line" [innerHTML]="textReport.content"></p>
  </dd>
  <hr *ngIf="!lastitem">
</ng-container>
`,
  styles: [``, `.required-field{color:red}.padding-l-5{padding-left:5px}.whitespace{margin-left:5px}.max-w-h-100{max-width:100%;max-height:100%}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.carousel-control.left{background-repeat:repeat-x}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control.right{background-image:linear-gradient(to right,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-repeat:repeat-x}.scroll{overflow-y:scroll;overflow-x:hidden}.div-simulator-form-height{height:calc(100vh - 100px);overflow-y:scroll;overflow-x:hidden}.div-report-text-scroll{overflow-x:hidden;overflow-y:auto;max-height:calc(100vh - 300px)}.padding-r-10{padding-right:10px}.slide-left{left:30px}.slide-right{right:30px}hr{margin-top:10px;margin-bottom:10px}.white-space-line{white-space:pre-line;word-wrap:break-word}p{margin:0 0 10px}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}h4.modal-title.float-left{float:left}.margin-b-0{margin-bottom:0}.font-weight-400{font-weight:400}.custom-radio-style{float:left;margin-right:15px}.zoom{width:100%;overflow:auto}.zoom img{height:auto;width:100%;min-width:100%;max-width:inherit!important}.btn-zoom{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-zoom.hover,.btn-zoom:active,.btn-zoom:hover{background-color:#e7e7e7}@media (min-width:768px){label.control-label{padding-left:20px}}.padding-5{padding:5px}`]
})
export class AssistReportTextComponent implements OnChanges {

@Input() reportText: MainReportText;
allReportTexts: AllReportText [] = [];
selectedSection: string;
mainReportTexts: MainReportText;
selectedSectionId: string;
allTextReport: AllTextReport[];
sections: string [] = [];
prevSectionId: string;
ngOnChanges(changes: SimpleChanges): void {
  this.mainReportTexts = new MainReportText();
  this.onSelect(this.selectedSectionId);
}
  constructor() {
      setInterval(() => {
    }, 1000);
   }

  onSelect(sectionId) {
   // console.log(this.reportText.allReportText);
    this.selectedSectionId = sectionId;
    this.sections = [];
    this.selectedSection = null;
    for (const section in this.reportText.allReportText) {
      if (this.reportText.allReportText[section].reportText !== '') {
        this.sections.push(section);
      }
    }
    if (sectionId === 'undefined' || sectionId === undefined || sectionId === 'All' ) {
      let allText: string;
      this.allTextReport = [];
      allText = '';
      for (const section in this.reportText.allReportText) {
        if (this.reportText.allReportText[section].reportText !== '') {
          const textReport: AllTextReport = new AllTextReport();
          textReport.heading =  section;
          textReport.content = this.removeEmptyLine(this.reportText.allReportText[section].reportText);
          this.allTextReport.push (textReport);
        }
      }
      this.selectedSectionId = 'All';
    }

    for (const section in this.reportText.allReportText) {
      if (this.reportText.allReportText[section].sectionId === sectionId) {
        this.selectedSection = this.reportText.allReportText[section].reportText;
        this.selectedSection = this.reportText.reportTextMainContent + ((this.selectedSection !== undefined && this.selectedSection !== '') ? this.removeEmptyLine(this.selectedSection) : '');
        break;
      }
    }
    this.mainReportTexts = new MainReportText();
    this.allReportTexts = [];
    for (const section in this.reportText.allReportText) {
      const allreportText = new AllReportText();
      allreportText.reportText = this.removeEmptyLine(this.reportText.allReportText[section].reportText);
      allreportText.sectionId = this.reportText.allReportText[section].sectionId;
      this.allReportTexts.push(allreportText);
    }
    this.mainReportTexts.allReportText = this.allReportTexts;
    this.mainReportTexts.reportTextMainContent = this.reportText.reportTextMainContent;
}
removeEmptyLine(inputText: string): string {
    if (inputText.trim().length !== 0) {
      const lines = inputText.split('\n');
      const uniquelines = [];
      lines.forEach( function (line, i) {
          if (line.trim().length !== 0) {
            uniquelines.push(line);
          }
      });
      return uniquelines.join('\n');
    }
  }
}
